import { connect } from 'react-redux';
import { compose, withHandlers, withProps } from 'recompose';
import { withTranslation } from 'react-i18next';
import moment from 'moment-timezone';

import {
  actions as shipmentsActions,
  selectors as shipmentsSelectors,
} from 'state/shipments';
import { actions as dorDropOffActions } from 'state/direct-order-recurring/drop-off';

import { methods as dateAndTimeMethods } from 'utils/dateAndTimes';

import RelativeDatePicker from 'components/form/RelativeDatePicker/component';
import {
  selectors as orderSelectors,
  selectors as orderSelector,
  selectorsByType,
} from 'state/order';

const PICKUP = 'pickup';

// ALl this part is full of magic numbers tiririr....
const generateOptions = ({ minDate, maxDate, t, days }) => {
  let currentDate = moment(minDate);
  const options = [];
  let i = 0;
  let limit = 2;
  if ((days.indexOf('5') >= 0 || days.indexOf('6') >= 0) && days.length === 1) {
    limit = days.indexOf('5') ? 3 : 4;
  }

  while (currentDate.isSameOrBefore(maxDate) && i < limit) {
    options.push({
      value: moment(currentDate).format('YYYY-MM-DD'),
      label: t(`RelativeDates.${limit <= 2 || i < limit - 1 ? i : 'mon'}`),
      index: i,
    });
    i += 1;

    currentDate = moment(currentDate).clone().add(1, 'day');
  }

  return options;
};

const enhance = compose(
  connect(
    (state, { shipmentKey, stopType }) => {
      const loadsInForm =
        orderSelector.maxNumberOfItemsInLoadsBetweenShipments(state);
      const typeOfOrder = orderSelector.getTypeOfOrder(state);
      const { min, max } = shipmentsSelectors.getMinAndMaxForDates(
        state,
        shipmentKey,
        stopType,
        'time_from',
        loadsInForm,
        typeOfOrder
      );

      return {
        value: shipmentsSelectors.getShipmentDate(state, shipmentKey, stopType)
          ? new Date(
              shipmentsSelectors.getShipmentDate(state, shipmentKey, stopType)
            )
          : undefined,
        minDate:
          stopType === PICKUP &&
          dateAndTimeMethods.canBeToday(
            shipmentsSelectors.getShipmentTimezone(state, shipmentKey, 'pickup')
          )
            ? moment()
                .tz(
                  shipmentsSelectors.getShipmentTimezone(
                    state,
                    shipmentKey,
                    'pickup'
                  )
                )
                .toDate()
            : min.value.toDate(),
        maxDate: stopType !== PICKUP ? max.value.toDate() : undefined,
        warnings: shipmentsSelectors.getShipmentTimesWarnings(
          state,
          shipmentKey,
          stopType
        ),
        days: selectorsByType.days[typeOfOrder].getDays(state),
        isRecurring: orderSelectors.getIsRecurringOrder(state),
      };
    },
    {
      changeDate: shipmentsActions.changeDate,
      setRecurringAddDays: dorDropOffActions.setAddDays,
    }
  ),
  withTranslation('dates'),
  withProps(({ minDate, maxDate, t, value, days }) => ({
    label: t('label.recurring'),
    options: generateOptions({ minDate, maxDate, t, days }),
    subLabel: '',
    value: moment(value).format('YYYY-MM-DD'),
  })),
  withHandlers(() => ({
    handleChange:
      ({
        changeDate,
        stopType,
        shipmentKey,
        setRecurringAddDays,
        isRecurring,
      }) =>
      ({ value, index }) => {
        if (isRecurring) {
          setRecurringAddDays(index);
        }
        const valueAsDate = new Date(value);
        changeDate({ value: valueAsDate, stopType, shipmentKey });
      },
  }))
);

export default enhance(RelativeDatePicker);
